import { createContext } from 'react';

export const GlobalContext = createContext({
  locale: {},
  network: {},
  provider: null,
});
